import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { RegisterComponent } from './views/register/register.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { ToastrModule } from 'ngx-toastr';
import { ComponentsModule } from './components/components.module';
import { HttpClientModule } from '@angular/common/http';
import { AuthComponent } from './auth/auth.component';
import { FormsModule } from '@angular/forms';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { FirebaseServiceProvider, firebaseInit } from './providers/firebase-service';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ModalModule } from 'ngx-bootstrap';
import { TableModule } from 'primeng/table';
import { StepsModule } from 'primeng/steps';
import DirectivesModule from './directives/directives.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AuthByUrlComponent } from './auth/auth-by-url.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    ChartsModule,
    AngularFirestoreModule ,
    ToastrModule.forRoot(),
    ComponentsModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    ModalModule.forRoot(),
    TableModule,
    StepsModule,
    DirectivesModule,
    AngularFireStorageModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    RegisterComponent,
    AuthComponent,
    AuthByUrlComponent,
    LoadingSpinnerComponent,
    ConfirmationDialogComponent
  ],
  providers: [
    FirebaseServiceProvider,
    { provide: APP_INITIALIZER, useFactory: firebaseInit, deps: [FirebaseServiceProvider], multi: true },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [ AppComponent ],
  entryComponents: [ConfirmationDialogComponent]
})
export class AppModule { }
